import { stripOuterQuotes } from '@common/html/util/style';
import { EditorEvent } from '@portal-core/project-files/events/editor-event.event';
import { StyleLabelNodeViewOptions } from '@portal-core/text-editor/node-views/models/style-label-node-view-options.model';
import { NodeViewBase } from '@portal-core/text-editor/node-views/node-view.base';
import { GetPosForNodeView } from '@portal-core/text-editor/node-views/types/nodeview-get-pos.type';
import { BidiBridge } from '@portal-core/util/bidi-bridge';
import { Node } from 'prosemirror-model';
import { Decoration, EditorView, NodeView } from 'prosemirror-view';

// Simple lookup table for mc-labels. These are actually defined in skin files and should ultimately use those.
const mcLabelLookups: Record<string, string> = {
  'Skin/Formats/CodeSnippetCopyButtonText(copy)': 'Copy'
};

function resolveMcLabel(label: string): string {
  return mcLabelLookups[label] ?? label;
}

export class StyleLabelNodeView extends NodeViewBase implements NodeView {
  /** Opt-in to sync the node when the stylesheet changes. */
  get syncNodeOnStylesheetChanges(): boolean {
    return true;
  }

  constructor(
    node: Node,
    editorView: EditorView,
    getPos: GetPosForNodeView,
    decorations: Decoration[],
    nodeViewBridge: BidiBridge<EditorEvent, EditorEvent>,
    private options: StyleLabelNodeViewOptions
  ) {
    super(node, editorView, getPos, decorations, nodeViewBridge);

    // Sync the node
    this.syncNode(node);
  }

  syncNode(node: Node) {
    // Grab the mc styles for the label
    const rawLabel = stripOuterQuotes(getComputedStyle(this.dom).getPropertyValue('--mc-label')) || this.options?.defaultLabel || '';
    const label = resolveMcLabel(rawLabel);

    // Update the label text
    if (this.dom.textContent !== label) {
      this.dom.textContent = label;
      this.emitEvent('node-view-size-changed', { nodeName: node.type.name });
    }
  }
}
